var map = {
	"./dark-close.png": "cjHe",
	"./khalasPay-close.png": "hKpB",
	"./lavender-close.png": "YmH7",
	"./night-blue-close.png": "qNAr",
	"./orange-close.png": "y/hK",
	"./regular-close.png": "8TWg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iEys";


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*\-close\.png$
// module id = iEys
// module chunks = 9